import { render, staticRenderFns } from "./DiabetesWidget.vue?vue&type=template&id=fe51e00e&scoped=true&"
import script from "./DiabetesWidget.vue?vue&type=script&lang=js&"
export * from "./DiabetesWidget.vue?vue&type=script&lang=js&"
import style0 from "./DiabetesWidget.vue?vue&type=style&index=0&id=fe51e00e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe51e00e",
  null
  
)

export default component.exports